export default __webpack_public_path__ + "locales/sr-Latn-RS/ConvertPasswordDialog.json?hash=54fcef4eceff0e945f5be57524283b7b";